module.exports = __webpack_public_path__ + "img/insurance.3d4da4da.jpg";